const ProfileData = {
  Faculty: [
    {
      name: "Dr. Ebin Deni Raj",
      email: "ebindeniraj@iiitkottayam.ac.in",
      phone: "+91 (0) 482-2202195",
      linkedin: "https://www.linkedin.com/in/ebin-deni-raj-153b8742/",
      website:"",
      image: "ebindeniraj.png",
      designation: "Faculty- IIIT KOTTAYAM",
      research: [
        "Responsible AI",
        "Explainable & Interpretable AI",
        "Data Science",
      ],
    },

    {
      name: "Dr. Arun Cyril Jose",
      email: "aruncyril@iiitkottayam.ac.in",
      phone: "+91 (0) 482-2202159",
      linkedin: "https://www.linkedin.com/in/dr-arun-cyril-jose-a62a8299/",
      website:"",
      image: "aruncyril.png",
      designation: "Faculty- IIIT KOTTAYAM",
      research: ["Privacy", "Security based Social Engineering"],
    },

    {
      name: "Dr. Gayathri G. R",
      email: "gayathri@iiitkottayam.ac.in",
      phone: "+91 (0) 482-2202184",
      linkedin: "https://www.linkedin.com/in/dr-gayathri-g-r-802781244/",
      website:"",
      image: "gayathri.png",
      designation: "Faculty- IIIT KOTTAYAM",
      research: ["Digital Humanities", "Cultural Analytics","GeoSpatial Analysis"],
    },

    {
      name: "Dr. Jayakrushna Sahoo",
      email: "jsahoo@iiitkottayam.ac.in",
      phone: "+91 (0) 482-2202164",
      linkedin: "https://www.linkedin.com/in/jayakrushna-sahoo-14932232/",
      website:"",
      image: "jsahoo.png",
      designation: "Faculty- IIIT KOTTAYAM",
      research: ["Machine Learning", "Data Mining"],
    },

    {
      name: "Dr. Josit Mariya",
      email: "jositmariya@iiitkottayam.ac.in",
      phone: "+91 (0) 482-2202203",
      linkedin: "https://www.linkedin.com/in/josit-mariya-93ab3a253/",
      website:"",
      image: "JS.jpg",
      designation: "Faculty- IIIT KOTTAYAM",
      research: ["Cultural Hegemony", "Sociological Studies"],
    },
    {
      name: "Dr.Divya Sindhu Lekha",
      email: "divyaslekha@iiitkottayam.ac.in",
      phone: "+91 (0) 482-2202161",
      linkedin: "https://www.linkedin.com/in/divyalekha/",
      website:"",
      image: "divyasindhulekha.png",
      designation: "Faculty- IIIT KOTTAYAM",
      research: ["Graph Theory", "Network Science", "Algorithms"],
    },
    {
      name: "Dr.Jeena Thomas",
      email: "jeenathomas@iiitkottayam.ac.in",
      phone: "+91 (0) 482-2202278",
      linkedin: "https://www.linkedin.com/in/jeena-thomas-456149167/",
      website:"",
      image: "jeena_thomas.jpeg",
      designation: "Faculty- IIIT KOTTAYAM",
      research: ["Computer Vision","Image Processing","Responsible Artificial Intelligence"],
    },
    {
      name: "Dr. Sara Renjit",
      email: "sararenjit@iiitkottayam.ac.in",
      phone: "+91 (0) 04822202299",
      linkedin: "https://www.linkedin.com/in/sara-renjit/?originalSubdomain=in",
      website:"https://www.iiitkottayam.ac.in/#!/faculty/sara",
      image: "Sara.jpeg",
      designation: "Faculty- IIIT KOTTAYAM",
      research: ["Natural Language Processing", "Explainable AI","DevOps & Agile"],
    },
    {
      name: "Dr. Sushitha Susan Joseph",
      email: "sushithasj@iiitkottayam.ac.in",
      phone: " 04822202257",
      linkedin: "https://www.linkedin.com/in/sara-renjit/?originalSubdomain=in",
      website:"https://iiitkottayam.ac.in/#!/faculty/sushitha",
      image: "Sushitha.jpeg",
      designation: "Faculty- IIIT KOTTAYAM",
      research: ["Machine Learning", "Deep Learning", "Medical Image Processing"],
    },
    {
      name: "Dr.Ansith S",
      email:"ansiths@iiitkottayam.ac.in",
      phone: "0482-2202229",
      linkedin: "https://www.linkedin.com/in/ansith-s-b12b2a67/?originalSubdomain=in",
      website:"https://www.iiitkottayam.ac.in/#!/faculty/ansiths",
      image: "Ansith_Sivadasan.JPG",
      designation: "Faculty- IIIT KOTTAYAM",
      research: ["Remote sensing","Computer vision", "Deep learning", "Explainable AI", "image processing"],

    },
    {
      name: "Dr. Anu Maria Sebastian",
      email:"anumaria@iiitkottayam.ac.in",
      phone: "04822202228",
      linkedin: "https://www.linkedin.com/in/anumseb/",
      website:"https://www.iiitkottayam.ac.in/#!/faculty/anumaria",
      image: "anumaria.jpg",
      designation: "Faculty- IIIT KOTTAYAM",
      research: ["Data centric AI and missing data imputation","Data analysis for Healthcare  Explainable AI" , "Multimodal AI systems"],

    },
  ],
  PhDScholars: [
    
    {
      name: "Shahad P",
      linkedin: "",
      image: "shahad.png",
      position: "Research Scholar",
    },
    {
      name: "Ashly Ann Jo",
      linkedin: "https://www.linkedin.com/in/ashly-ann-jo-b18695145/",
      image: "ashly.jpg",
      position: "Research Scholar",
    },
    {
      name: "Remya Raveendran",
      linkedin: "https://www.linkedin.com/in/remya-raveendran-7293444a/",
      image: "Remya_Raveendran.jpeg",
      position: "Research Scholar",
    },
    {
      name: "Mahesh Sasikumar",
      linkedin: "https://www.linkedin.com/in/mahesh-sasikumar-iiitk-4606192a3/",
      image: "Mahesh.jpg",
      position: "Research Scholar",
    },
    
    
    {
      name: "Anitha Ambat",
      linkedin: "https://www.linkedin.com/in/anitha-ambat-198a36243",
      image: "Anitha_Ambat.png",
      position: "Research Scholar",
    },
    {
      name: "Ruchi Rani",
      linkedin: "https://www.linkedin.com/in/ruchi-rani-85873153/",
      image: "Ruchi_Rani.jpeg",
      position: "Research Scholar",
    },
    {
      name: "Sreekala",
      linkedin: "",
      image: "",
      position: "Research Scholar",
    },
    {
      name: "Renji S",
      linkedin: "https://www.linkedin.com/in/renji-s-157083253/",
      image: "Renji_S.png",
      position: "Research Scholar",
    },
    {
      name: "Akshaya Suresh",
      linkedin: "https://www.linkedin.com/in/akshaya-suresh-39a63b18a/",
      image: "Akshaya_Suresh.jpeg",
      position: "Research Scholar",
    },
    {
      name: "Sheema Madhusudhanan",
      linkedin: "https://www.linkedin.com/in/sheema-madhusudhanan-83410825b",
      image: "Sheema_Madhusudhanan.png",
      position: "Research Scholar",
    },
    {
      name: "Dhanya P",
      linkedin: "",
      image: "",
      position: "Research Scholar",
    },
   
    {
      name: "Neethu Krishna",
      linkedin: "https://www.linkedin.com/in/neethu-krishna-29b667235",
      image: "Neethu_Krishna.png",
      position: "Research Scholar",
    },
    {
      name: "Julie Sara Benny",
      linkedin: "https://www.linkedin.com/in/julie-sara-benny-b60698237/",
      image: "Julie Sara Benny.png",
      position: "Research Scholar",
    },
    {
      name: "Helena Thomas",
      linkedin: "https://www.linkedin.com/in/helena-thomas-b15081114",
      image: "Helena_Thomas.png",
      position: "Research Scholar",
    },
    {
      name: "Aparna Unnikrishnan",
      linkedin: "https://www.linkedin.com/in/aparnau004/",
      image: "Aps.jpeg",
      position: "Research Scholar",
    },
    {
      name: "Juliet Anu Toms",
      linkedin: "https://www.linkedin.com/in/juliet-anu-toms-a534b929b/",
      image: "Juliet.jpeg",
      position: "Research Scholar",
    },
  ],
  MTech: [
   
    {
      name: " Laxmi Priya Kasi",
      linkedin: "",
      image: "LAXMI PRIYA KASI -.jpg",
      position: "Machine Learning Engineer, Clinical AI Team, Apollo Hospitals",
    },
    
  ],
  UG: [
   
    {
      name:"Harissh Ragav Dhamodaran",
      linkedin:"",
      image:"HARISSH RAGAV DHAMODARAN.jpeg",
      position:""

    },
    {
      name:" Vidya Kaarthika Akella",
      linkedin:"",
      image:"VIDYA KAARTHIKA A -IIITK.jpeg",
      position:""

    },
    {
      name:" Suraj Nagunuri",
      linkedin:"",
      image:"Suraj Nagunuri.jpg",
      position:""

    },
    {
      name:"Bavishya Sankaranarayanan",
      linkedin:"",
      image:"Bavishya S.jpg",
      position:""

    },
    {
      name:"Lochana Balivada",
      linkedin:"",
      image:"LOCHANA BALIVADA.jpg",
      position:"CSE"

    },
    {
      name:"Shivkarthik Suresh ",
      linkedin:"",
      image:"Shivkarthik Suresh.jpg",
      position:"CSE"

    },
    
    {
      name: "Suraj Nagunuri",
      linkedin: "",
      image: "Suraj Nagunuri.jpg",
      position: "CSE",
    },

    {
      name: "Rithika E",
      linkedin: "",
      image: "Rithika E.jpg",
      position: "CSE ",
    },

    {
      name: "Badam Malavika",
      linkedin: "",
      image: "BADAM MALAVIKA.jpg",
      position: "CSE ",
    },

    {
      name: "J Glen Enosh",
      linkedin: "",
      image: "J GLEN ENOSH.jpg",
      position: "CSE  AI & DS",
    },
    
  ],
  Interns: [
   {
      name:"Oliva Jayakanthan",
      linkedin:"",
      image:"IM oliva.jpg",
      position:""

    },
  
    {
      name:"Ashwin P.S",
      linkedin:"",
      image:"Ashwin P S.jpg",
      position:""

    },
    
    {
      name:"Aseem T A",
      linkedin:"",
      image:"Aseem.jpg",
      position:""

    },
   
    {
      name:"  SREEKUTTY C S",
      linkedin:"",
      image:"SREEKUTTY CS.jpg",
      position:""

    },
    {
      name:" Franklin James ",
      linkedin:"",
      image:"Franklin James.jpg",
      position:""

    },
    
    {
      name:" Ajay Thomas ",
      linkedin:"",
      image:"ajay thomas.jpg",
      position:""

    },
 
    {
      name:" Gayathri Anil ",
      linkedin:"",
      image:"Gayathri Anil.jpeg",
      position:""

    },
   
     {
      name:"  ABHIRAMI S ",
      linkedin:"",
      image:"abhirami s.jpg",
      position:""

    },
    {
      name:" Neha jimmy ",
      linkedin:"",
      image:"Neha Jimmy.jpg",
      position:""

    },

     {
      name:" Athulya Alex ",
      linkedin:"",
      image:"athulya alex.jpg",
      position:""

    },

    {
      name:"Boddu Navyasree",
      linkedin:"",
      image:"navyasree navyasreeboddu.jpeg",
      position:""

    },
    
     {
      name:"Gauri Nandana G",
      linkedin:"",
      image:"Gauri Nandana.jpg",
      position:""

    },
    {
      name:"Andriya Kurian",
      linkedin:"",
      image:"Andriya Kurian.jpg",
      position:""

    },
    {
      name:"Aditi Krishnan ",
      linkedin:"",
      image:"ADITI KRISHNAN.jpg",
      position:""

    },

    
    {
      name:"Naznin M Ali",
      linkedin:"",
      image:"Naznin.jpg",
      position:""

    },
    {
      name:"Arundhathi Nair S",
      linkedin:"https://www.linkedin.com/in/arundhathi-nair-s/",
      image:"arundh.png",
      position:""
    },
    {
      name:"Caina Rose Paul",
      linkedin:"https://www.linkedin.com/in/caina-rose-paul-4b96521ab/",
      image:"caina.png",
      position:""
    },
    {
      name:"Navya S Raj",
      linkedin:"https://www.linkedin.com/in/navya-s-raj-926602202/",
      image:"navya.png",
      position:""
    },
    {
      name:"Revathy Sanil",
      linkedin:"https://www.linkedin.com/in/revathy-sanil-b1905a226/",
      image:"revathy.png",
      position:""
    },
    {
      name:"Evana Elsa Bose",
      linkedin:"https://www.linkedin.com/in/evana-elsa-bose/",
      image:"evana.png",
      position:""
    },
    {
      name:"Mariya John",
      linkedin:"",
      image:"mariya.png",
      position:""
    },
    {
      name: "Angel Susan Vino",
      linkedin: "https://www.linkedin.com/in/angel-susan-vino-1920931b8/",
      image: "",
      position: "",
    },
    {
      name: "Parvathy V Menon",
      linkedin: "https://www.linkedin.com/in/parvathy-menon-92a160218/",
      image: "Parvathy_V_Menon.jpeg",
      position: "",
    },
    {
      name: "Sikha S",
      linkedin: "",
      image: "",
      position: "",
    },
    {
      name: "Dhimant Morakhia",
      linkedin: "https://www.linkedin.com/in/dhimant-morakhia/",
      image: "Dhimant_Morakhia.jpeg",
      position: "",
    },
  ],
  Alumni: [
    {
      name: "Chinju John",
      linkedin: "https://https://www.linkedin.com/in/chinju-john-a95876b4/",
      image: "chinju.png",
      position: "CSE",
    },
     {
      name: "Jisha Mariyam John",
      linkedin: "https://www.linkedin.com/in/jisha-mariyam-john-14575294/",
      image: "JISHA_MARIYAM_JOHN.png",
      position: "CSE",
    },
    {
      name: "Akarsh Nair",
      linkedin: "https://www.linkedin.com/in/akarsh-k-nair-03298220b/",
      image: "akarsh.png",
      position: "CSE",
    },
    {
      name: "Subodh Uniyal",
      linkedin: "https://www.linkedin.com/in/subodh7300/",
      image: "SUBODH_UNIYAL.png",
      position: "CSE",
    },
    {
      name: "Raunak Kumar Singh",
      linkedin: "https://www.linkedin.com/in/raunak554/",
      image: "raunak.png",
      position: "CSE",
    },
    {
      name: "Jasmin Bheda",
      linkedin: "https://www.linkedin.com/in/jasmin-bheda-407419202",
      image: "jasmin.jpeg",
      position: "CSE",
    },
    {
      name: "Maitri Deepak Savla",
      linkedin: "https://www.linkedin.com/in/maitri-savla-a5544b229",
      image: "MAITRI_DEEPAK_SAVLA.png",
      position: "CSE",
    },
    {
      name: "Tushar K",
      linkedin: "https://www.linkedin.com/in/tushaar9560",
      image: "TUSHAAR.png",
      position: "CSE",
    },
    {
      name: "Dhivyesh",
      linkedin: "https://www.linkedin.com/in/dhivyesh-rk/",
      image: "DHIVYESH_R_K.png",
      position: "CSE",
    },
    {
      name: "Anish Reddy Konyala",
      linkedin: "https://linkedin.com/in/anish-reddy-konyala-9496ab229/",
      image: "KONYALA_ANISH_REDDY.png",
      position: "CSE",
    },
    {
      name: "Kashyap Chandra",
      linkedin: "https://www.linkedin.com/in/kashyap-chandra-7a1132218",
      image: "kashyap_chandra.png",
      position: "CSE",
    },
    {
      name: "Hardik Somkuwar",
      linkedin: "https://www.linkedin.com/in/hardik-somkuwar-761aa921b/",
      image: "SOMKUWAR_HAR_DIKPRAKASH.jpg",
      position: "CSE",
    },
    {
      name: "Ranjith R",
      linkedin: "https://www.linkedin.com/in/ranjith-r-3656aa10b/",
      image: "ranjith.png",
      position: "ML Engineer @ IBS Software ",
    },
    {
      name: "Susmera Joseph",
      linkedin: "https://www.linkedin.com/in/susmera-joseph-769a3937/",
      image: "SUSMERA_JOSEPH.png",
      position: "Full Stack Developer @DEWA Centre",
    },
    {
      name: "Ijas AH",
      linkedin: "https://www.linkedin.com/in/ijas-ah/",
      image: "Ijas_A_H.png",
      position: "Deep Learning Engineer @cognizant",
    },
    {
      name: "Selvaraj Mariyappan",
      linkedin: "https://www.linkedin.com/in/selvaraj-mariyappan-12629864/",
      image: "SELVARAJ_MARIYAPPAN.png",
      position: "Solution Architect @ Vantiva",
    },
    {
      name: "Thiruthuvaraj Rajshekar",
      linkedin: "",
      image: "raja.jpeg",
      position: "Department of CSE",
    },
    {
      name: "Bhagya J",
      linkedin: "https://www.linkedin.com/in/bhagya-j-589237125",
      image: "Bhagya_J.png",
      position: "Senior Software Engineer(AI) @QuEST Global",
    },
    {
      name: "Amal Das",
      linkedin: "https://www.linkedin.com/in/amal-das-4006b482/",
      image: "Amal_Das.png",
      position: "Senior Software Engineer @AppViewX",
    },
    {
      name: "Sai Tejashwin Eswarapu",
      linkedin: "",
      image: "Sai_Tejashwin_Eswarapu.jpeg",
      position: "SDE @Perfios",
    },
    {
      name: "Yashwanth Deshaboina",
      linkedin: "https://www.linkedin.com/in/yashwanth-deshaboina-1799471b0/",
      image: "Yashwanth_Deshaboina.jpeg",
      position: "AI and ML",
    },
    {
      name: "Seshathri S",
      linkedin: "https://www.linkedin.com/in/seshathri-s-32a5281a5/",
      image: "Seshathri_S.jpeg",
      position: "Associate Software Engineer @Palo Alto Networks",
    },
    {
      name: "Bhargawa P",
      linkedin: "https://www.linkedin.com/in/bhargawa-potharaju-779068242/",
      image: "Bhargawa.png",
      position: "Department of CSE",
    },
    {
      name: "Nithin A",
      linkedin: "https://www.linkedin.com/in/nithin-a-19635520a",
      image: "A_Nithin.png",
      position: "Software engineer @QBurst",
    },
  ],
  International_Collaborators: [
    {
      name:"Prof. Petra Ahrweiler",
      linkedin:"https://www.linkedin.com/in/petra-ahrweiler-95b9423/",
      image:"petra.png",
      position:"Johannes Gutenberg University Mainz, Germany"
    }
  ],
  Industry_Experts: [
    {
      name:"Jibu Elias",
      linkedin:"",
      image:"jibu.png",
      position:"INDIA Al,Nasscom"
    },
    {
      name:"Supriya Bhuwalka",
      linkedin:"",
      image:"supriya.png",
      position:"Founder, Coding and More"
    }
  ]
};

export default ProfileData;
